import { Col, Row } from "antd";
import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import AppContext from "../../../context/app/context";
import EndPoints from "../../../services/end-points";
import Form from "../../form-components/from";
import { INITIAL_PAGE } from "../../../utils/helpers/constants";
import FieldBuilder from "../../form-components/field-builder";
import PaymentDeliveryWorkerContext from "../../../context/payment-delivery-worker/context";
import { getPaymentStatus } from "../../../models/payment-delivery-worker/enum";
import { useLocation } from "react-router-dom";
import { addSearchToURL, filtersToQueryString, getFiltersFromURL, getKeywordFromURL } from "../../../utils/helpers/url";

interface IProps { }

const PaymentDeliveryWorkerFilter: React.FC<IProps> = () => {
    const { t } = useTranslation();
    const { actions, query } = useContext(PaymentDeliveryWorkerContext);
    const { direction } = useContext(AppContext);
    const [delivery, setDelivery] = useState<any[]>([]);
    const [deliveryLoading, setDeliveryLoading] = useState(true);

    const location = useLocation();
    const [initialValues, setInitialValues] = useState<Record<string, any>>({});

    useEffect(() => {
        const filters = getFiltersFromURL();

        const initialValuesObj = {};
        filters.forEach((f) => {
            initialValuesObj[f.name] = f.value;
        });

        setInitialValues(initialValuesObj);
    }, [location.search]);
    useEffect(() => {
        const getDelivery = async () => {
            try {
                const { data } = await EndPoints.deliveryWorkers.getAllDeliveryWorkers({
                    light: true,
                    perPage: -1,
                });
                setDelivery(data.data);
                setDeliveryLoading(false);
            } catch (error) {
            } finally {
                setDeliveryLoading(false);
            }
        };
        getDelivery();
    }, [direction]);

    return (
        <Form
            formId="payment-delivery-worker-filter"
            defaultValues={initialValues}
            onSubmit={(data) => {
                const keyword = getKeywordFromURL();
                const filter: any = {
                    page: INITIAL_PAGE,
                    perPage: query?.perPage,
                    keyword: keyword,
                    filters: [
                        data?.isConfirmed
                            ? {
                                name: "isConfirmed",
                                value: data.isConfirmed,
                                operation: "eq",
                            }
                            : undefined,
                        data?.driverId
                            ? {
                                name: "driverId",
                                value: data.driverId,
                                operation: "eq",
                            }
                            : undefined,
                        data?.createdAt != undefined &&
                            data.createdAt[0] != ""
                            ? {
                                name: "createdAt",
                                value: data.createdAt[0],
                                operation: "gte",
                            }
                            : undefined,
                        data?.createdAt != undefined &&
                            data.createdAt[1] != ""
                            ? {
                                name: "createdAt",
                                value: data.createdAt[1],
                                operation: "lte",
                            }
                            : undefined,
                    ].filter((f) => f),
                };
                const queryString = filtersToQueryString(filter.filters);
                window.history.replaceState(null, "", `?${queryString}`);
                addSearchToURL(keyword);
                actions.setQuery(filter);
            }}
        >
            <Row justify={"start"} gutter={[10, 0]}>
                <Col xs={24} sm={24} md={8} lg={8} xl={8} xxl={8}>
                    <FieldBuilder
                        name="isConfirmed"
                        label={`${t("payment_status")}`}
                        width="large"
                        input={{
                            type: "select",
                            options: [1, 2, 3].map((status, index) => {
                                return {
                                    label: t(getPaymentStatus(status) as string),
                                    value: status as number,
                                };
                            }),
                        }}
                    />
                </Col>
                <Col xs={24} sm={24} md={8} lg={8} xl={8} xxl={8}>
                    <FieldBuilder
                        name="driverId"
                        label={`${t("delivery_worker")}`}
                        width="large"
                        input={{
                            type: "select",
                            allowSearch: true,
                            loading: deliveryLoading,
                            options: delivery.map((delivery, index) => {
                                return {
                                    label: delivery.firstName,
                                    value: delivery.id,
                                };
                            }),
                        }}
                    />
                </Col>
                <Col xs={24} sm={24} md={8} lg={8} xl={8} xxl={8}>
                    <FieldBuilder
                        name="createdAt"
                        label={`${t("created_at")}`}
                        input={{ type: "range-picker" }}
                        rules={{ required: false }}
                    />
                </Col>
            </Row>
        </Form>
    );
};

export default PaymentDeliveryWorkerFilter;
